import Navigation from "../components/Navigation";
import Contact from "../components/Contact";
import Price from "../components/Price";
import ProductsList from "../components/ProductsList";
import '../components/styles.css'
import { useEffect } from "react";
import useTitle from "@nooks/use-title";

function Products({userObj, isLoggedIn}){
    useTitle("캐리빌리_캐리어 보기")
    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])
    return (
        <div>
            <Navigation userObj={userObj} isLoggedIn={isLoggedIn} />
            <div style={{marginTop: "2rem"}}></div>
            <Price />
            <ProductsList />
            <Contact />
        </div>
    );
}

export default Products;